import axiosAuth from '../../axiosMain';
import store from '@/store';

async function index() {
  try {
    let response = await axiosAuth.get('/categories');
    return response.data.data;
  } catch (e) {}
}

async function resiliencyCategories() {
  let categories = await store.dispatch('refreshCategories');
  return sortCategories(categories);
}

function sortCategories(categories) {
  let filtered_categories = categories.filter(function (category) {
    if (category.name === 'membershipEngagement') category.name = 'membership engagement';
    return category.name === 'disaster' || category.name === 'membership engagement' || category.name === 'finance';
  });
  return filtered_categories.sort(function (category_1, category_2) {
    return category_2.name - category_1.name;
  });
}

export default {
  index,
  resiliencyCategories,
};
